export enum EventType {
  Charge = 0,
  Drop = 1,
  UNUSED = 2, // Used to be 'name', but no longer used.
  Manual = 3,
  Dryend = 4,
  Firstcrack = 5,
  AutoFirstcrack = 6,
  AutoDryend = 7,
  AutoDrop = 8,
  TurningPoint = 99,
}

export const EventTypeString = {
  [EventType.Charge]: 'chartevent.charge',
  [EventType.Drop]: 'chartevent.drop',
  [EventType.UNUSED]: '',
  [EventType.Manual]: 'chartevent.manual',
  [EventType.Dryend]: 'chartevent.dryend',
  [EventType.Firstcrack]: 'chartevent.firstcrack',
  [EventType.AutoFirstcrack]: 'chartevent.autofirstcrack',
  [EventType.AutoDryend]: 'chartevent.autodryend',
  [EventType.AutoDrop]: 'chartevent.autodrop',
  [EventType.TurningPoint]: 'chartevent.turningpoint',
}

export const EventFlag = {
  EVENT_FLAG_CHARGE: 1 << 1,
  EVENT_FLAG_DROP: 1 << 2,
  EVENT_FLAG_FIRSTCRACK: 1 << 3,
  EVENT_FLAG_NAME: 1 << 4,
  EVENT_FLAG_DRYEND: 1 << 5,
  EVENT_FLAG_MANUAL: 1 << 6,
}
